import { getProxyUrl } from '@proxies/index'

export default async function fetchTexturas(id: number) {
  const _info = await fetch(getProxyUrl(`api/acabados/gettexturas/${id}`), {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Accept-Language': 'ES',
      Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
    },
  })
  return _info.json()
}
